import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const BookPage = () => {
  return (
    <Layout>
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">Horse Agility met Kay & Honey</h1>

        {/* Mede mogelijk gemaakt dankzij Section */}
        <section className="mb-16">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">
            Mede mogelijk gemaakt dankzij
          </h2>
          <div className="flex justify-center mb-8">
            <img
              src="/images/level-up-logo.jpg"
              alt="Level-Up Magazine"
              className="max-w-full h-auto rounded-lg shadow-lg"
            />
          </div>
          <div className="text-center">
            <a
              href="https://www.level-upmagazine.nl/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary/90 transition-colors"
            >
              Meer info over Level-Up magazine? Klik hier!
            </a>
          </div>
        </section>

        {/* Introduction Section */}
        <section className="mb-16">
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed text-center max-w-3xl mx-auto">
            De paardvriendelijke sport Horse Agility krijgt in Nederland en België steeds meer bekendheid. 
            Het is niet alleen een sport die je serieus op wedstrijdniveau kunt beoefenen, maar het is ook 
            een zinvolle afwisseling in de training en om een diepere band op te bouwen met je paard.
          </p>
        </section>

        {/* Divider */}
        <div className="border-t border-gray-300 my-16"></div>

        {/* Achievements Section */}
        <section className="mb-16">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-lg text-gray-700 leading-relaxed">
                Dankzij onze deelnames aan competities ben ik 2x reserve wereldkampioen, Europees kampioen, 
                officieel ambassadeur en erkend instructeur bij The international Horse Agility Club.
              </p>
            </div>
            <div>
              <img
                src="/images/book-img-1.jpg"
                alt="Horse Agility"
                className="rounded-lg shadow-lg w-full h-auto"
              />
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className="border-t border-gray-300 my-16"></div>

        {/* Book Content Section 1 */}
        <section className="mb-16">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <img
                src="/images/book-img-2.jpg"
                alt="Horse Agility Training"
                className="rounded-lg shadow-lg w-full h-auto"
              />
            </div>
            <div>
              <p className="text-lg text-gray-700 leading-relaxed">
                In dit boek vertel ik veel meer dan alleen hoe te starten met Horse Agility. Ik vertel ook 
                hoe ik mijn paarden train en, niet onbelangrijk, waarom ik er voor kies om zo samen te werken. 
                Daarnaast vertel ik verschillende wetenswaardigheden over het paard en hun zintuigen en waarom 
                je kennis hierover best van groot belang is als je met je paard aan de slag gaat.
              </p>
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className="border-t border-gray-300 my-16"></div>

        {/* Book Content Section 2 */}
        <section className="mb-16">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-lg text-gray-700 leading-relaxed">
                Verder geef ik alle tools om te starten met clickertraining en hoe je dit kunt toepassen in 
                combinatie met Horse Agility. Ook vertel ik hoe je je paard die o zo belangrijke positieve 
                associatie met obstakels helpt te maken. En we gaan verder dan alleen de basis, ik leer je 
                om zelf creatief te zijn om moeilijkere uitdagingen aan te gaan.
              </p>
            </div>
            <div>
              <img
                src="/images/book-img-3.jpg"
                alt="Horse Agility Training"
                className="rounded-lg shadow-lg w-full h-auto"
              />
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className="border-t border-gray-300 my-16"></div>

        {/* Book Content Section 3 */}
        <section className="mb-16">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <img
                src="/images/book-img-4.jpg"
                alt="Horse Agility Training"
                className="rounded-lg shadow-lg w-full h-auto"
              />
            </div>
            <div>
              <p className="text-lg text-gray-700 leading-relaxed">
                Alles wordt stap voor stap uitgelegd met behulp van ruim 150 foto's. Het beste leer je door 
                zelf aan de slag te gaan en daarom vind je in het boek inspiratieparcoursen waarin maar liefst 
                200 opdrachten verwerkt zijn. Bij deze inspiratieparcoursen staan QR-codes met YouTube filmpjes 
                waarbij ik met Honey extra inspiratie laat zien.
              </p>
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className="border-t border-gray-300 my-16"></div>

        {/* Book Content Section 4 */}
        <section className="mb-16">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-lg text-gray-700 leading-relaxed">
                Als kers op de taart vertel ik hoe ik paarden op positieve manier leer om door een hoepel te 
                springen. En heb je echt de smaak te pakken dan kan je achter in het boek alle info vinden over 
                hoe te starten met competities bij The International Horse Agility Club. Maar het belangrijkste 
                is uiteraard om samen met je paard veel plezier te maken!
              </p>
            </div>
            <div>
              <img
                src="/images/book-img-5.jpg"
                alt="Honey, Pixie and Athena"
                className="rounded-lg shadow-lg w-full h-auto"
              />
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className="border-t border-gray-300 my-16"></div>

        {/* Video Section */}
        <section className="mb-16">
          <p className="text-lg text-gray-700 mb-8 text-center">
            1 van de video's in het boek zie je hieronder.
          </p>
          <div className="max-w-4xl mx-auto">
            <div className="relative pb-[56.25%] h-0 overflow-hidden rounded-lg shadow-xl">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/QEm1XCuOmfM"
                title="Horse Agility met Kay & Honey: Parcours 8"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className="border-t border-gray-300 my-16"></div>

        {/* Contact Section */}
        <section className="mb-16 text-center">
          <a
            href="mailto:kay.ruymaekers@gmail.com"
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary/90 transition-colors mb-8"
          >
            Meer vragen of bestellen?! Klik hier!
          </a>
          <div className="flex justify-center">
            <Link
              to="/leesvoer"
              className="group block max-w-md w-full rounded-lg shadow-lg overflow-hidden transition-all duration-200 hover:shadow-2xl hover:-translate-y-1"
              aria-label="Ga naar Ons boek"
            >
              <img
                src="/images/book-cover.jpg"
                alt="Horse Agility met Kay & Honey Boek Cover"
                className="w-full h-auto transition-transform duration-300 group-hover:scale-[1.02]"
              />
            </Link>
          </div>
        </section>
      </Layout>
  );
};

export default BookPage;

